module.exports = __webpack_public_path__ + "static/media/datagrity_logo.74c971ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/datagrity_logo.svg
// module id = 2
// module chunks = 0